import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import classNames from 'classnames';

const StyledSelect = styled(Select)`
  width: auto;
  flex-shrink: 0;
  min-width: 200px;
`;

const EventSelector = ({ event, changeUsersEvent, events, showNotValidFields = false }) => {
  const [isValid, setValid] = useState(true);

  useEffect(() => {
    if (showNotValidFields) {
      setValid(!!event);
    }
  }, [event, showNotValidFields]);

  const options = useMemo(
    () => [...events].sort((a, b) => a.localeCompare(b)).map((e) => ({ label: e, value: e })),
    [events]
  );

  return (
    <StyledSelect
      showSearch
      placeholder="Select an event"
      optionFilterProp="label"
      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
      value={event || undefined}
      className={classNames('ant-select-border-bottom', { 'not-valid': !isValid })}
      onChange={(e) => {
        changeUsersEvent(e);
      }}
      dropdownMatchSelectWidth
      allowClear
      getPopupContainer={(triggerNode) => triggerNode}
      virtual={false}
      options={options}
    />
  );
};

export default EventSelector;
